export default {
  name: 'Login On Global Nav',
  htmlId: 'loginOnGlobalNav',
};
